/*
by zhang.qiang 2017/03/08
 */
"use strict";
angular.module('manageSysManageSysOperationManagementModule', ['sysOperationManageServiceModule'])
    .controller('manageSysManageSysOperationManagementCtrl', ['$scope', '$modal', 'sysOperationManageService', 'trsHttpService', 'modalDialog', function($scope, $modal, sysOperationManageService, trsHttpService, modalDialog) {
        initStatus();
        initData();
        /**
         * [initStatus 初始化状态]
         * @return {[type]} [description]
         */
        function initStatus() {
            $scope.data = {
                items: [],
                selectedArray: []
            };
        }
        /**
         * [initData 初始化数据]
         * @return {[type]} [description]
         */
        function initData() {
            requestData();
        }
        /**
         * [requestData description]请求数据
         * @return {[type]} [description]
         */
        function requestData() {
            var params = {
                serviceid: 'mlf_operationalconfig',
                methodname: 'queryConfigs'
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                $scope.data.items = data;
            });
        }
        /**
         * [new description]新建
         * @return {[type]} [description]
         */
        $scope.new = function() {
            createOrEdit({ OPERATIONALCONFIGID: 0 }, "新建");
        };
        /**
         * [xiugai 修改]
         * @return {[type]} [description]
         */
        $scope.editSystem = function(item) {
            createOrEdit(item, "修改");
        };
        /**
         * [createOrEdit 新建或修改]
         * @param  {[object]} item [description] 修改对象
         * @param  {[string]} type [description] 类型
         * @return {[type]} [description]
         */
        function createOrEdit(item, type) {
            item.allSystems = $scope.data.items;
            sysOperationManageService.edit(item, function(result) {
                if (result == "success") {
                    modalDialog.alertType(type + '系统成功', "", "success", false, function() {
                        requestData();
                    });
                } else {
                    modalDialog.alertType(result.detail, result.detail == result.message ? "" : result.message, "error", false);
                }
            });
        }

        //叠次排序
        // $scope.sortSystem = function(item) {
        //     item.allSystems = $scope.data.items;
        //     sysOperationManageService.sort(item, function() {
        //         if (result == "success") {
        //             modalDialog.alertType('系统排序成功', "", "success", false, function() {
        //                 requestData();
        //             });
        //         } else {
        //             modalDialog.alertType(result.detail, result.detail == result.message ? "" : result.message, "error", false);
        //         }
        //     });
        // };

        /**
         * [deleteSys description]删除
         * @return {[type]} [description]
         */
        $scope.deleteSystem = function(item) {
            var ConfigIds = '';
            if (angular.isDefined(item)) {
                ConfigIds = item.OPERATIONALCONFIGID;
            } else {
                ConfigIds = $scope.data.selectedArray.map((item) => {
                    return item.OPERATIONALCONFIGID
                }).join(',');
            }
            modalDialog.confirmModal('删除', '确定删除所选系统', function() {
                var params = {
                    serviceid: "mlf_operationalconfig",
                    methodname: "deleteConfigs",
                    ConfigIds: ConfigIds
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                    modalDialog.alertType('删除系统成功', "", "success", false, function() {
                        requestData();
                        $scope.data.selectedArray = [];
                    });
                });
            });
        };
        /**
         * [selectAll description] 列表全选按钮
         * @return {[type]} [description]
         */
        $scope.selectAll = function() {
            $scope.data.selectedArray = $scope.data.selectedArray.length == $scope.data.items.length ? [] : [].concat($scope.data.items);
        };
        /**
         * [selectDoc description] 列表单选按钮
         * @param  {[type]} item [description]
         * @return {[type]}      [description]
         */
        $scope.selectDoc = function(item) {
            var flag = false
            $scope.data.selectedArray.forEach((itemchild, index) => {
                if (JSON.stringify(itemchild) == JSON.stringify(item)) {
                    flag = true;
                    $scope.data.selectedArray.splice(index, 1);
                }
            })
            if (!flag) {
                $scope.data.selectedArray.push(item);
            }
        };
    }]);